//法语
export default {
    login1: 'Vous avez déjà un compte ?',
    login2: 'Se connecter',
    login3: 'Mot de passe oublié ?',
    login4: 'Commencer avec 51shopy',
    login5: 'Mot de passe oublié ?',
    login6: "S'inscrire immédiatement",
    login7: 'E-mail',
    login8: 'Code de vérification',
    login9: 'Entrez le code de vérification',
    login10: 'Mot de passe',
    login11: 'Confirmer le mot de passe',
    login12: 'Veuillez entrer à nouveau le mot de passe',
    login13: "S'inscrire",
    login14: 'Étape suivante',
    login15: 'Soumettre',
    login16: 'Envoyer le code de vérification',
    login17: 'Veuillez entrer un e-mail et un code de vérification corrects !',
    login18: 'Les deux entrées de mot de passe ne sont pas identiques !',
    login19: 'Le code de vérification a été envoyé',
    login20: "L'e-mail ne peut pas être vide",
    login21: "Le format de l'e-mail est incorrect",
    login22: 'Le code de vérification ne peut pas être vide',
    login23: 'Le code de vérification doit contenir 4 caractères',
    login24: 'Le mot de passe ne peut pas être vide',
    login25: 'La longueur du mot de passe ne doit pas être inférieure à 6 caractères',
    login26: 'Modification du mot de passe réussie !',
    login27: 'Inscription réussie !',
    login28: 'Connexion réussie',
    login29: 'Le nom de compte ne peut pas être vide',
    login30: 'Connectez-vous ci-dessous pour commencer à utiliser votre compte',
    login31: 'Compte',
    login32: 'Cliquez pour vous connecter',
    login33: "Achetez des produits de qualité et bénéficiez des avantages",
    login34: "Inscrivez-vous pour recevoir un cadeau magnifique",
    login35: "Se connecter",
    login36: "S'inscrire",

    home1: 'Populaire',
    home2: 'Voulez-vous vraiment vous déconnecter ?',
    home3: 'Avertissement',
    home4: 'Confirmer',
    home5: 'Annuler',
    home6: 'Fans',
    home7: 'Suivre',
    home8: 'Centre personnel',
    home9: 'Mes achats',
    home10: 'Mes ventes',
    home11: 'Mon portefeuille',
    home12: 'Déconnexion',
    home13: 'Total de',
    home14: 'articles',
    home15: 'Règlement',
    home16: 'Prix abordables',
    home17: 'Expédition rapide',
    home18: 'Garantie de qualité',
    home19: 'À propos de nous',
    home20: 'Centre d\'aide',
    home21: 'Service après-vente',
    home22: 'Livraison et réception',
    home23: 'Partenariat commercial',
    home24: 'Recommandations de recherche',
    home25: 'Liens d\'amitié',
    home26: 'Suivre',
    home27: 'Déjà suivi',
    home28: 'ACHETER',
    home29: 'AJOUTER',
    home30: 'Ajout au favori réussi !',
    home31: 'Annulation du favori réussie !',
    home32: 'Voulez-vous vraiment vous désabonner ?',
    home33: 'Annulation réussie !',
    home34: 'Abonnement réussi !',
    home35: 'Le contenu ne peut pas être vide',
    home36: 'Commentaire réussi!',
    home37: 'Évaluation du produit',
    home38: 'Évaluer immédiatement',
    home39: 'Évaluation',
    home40: 'Historique',
    home41: 'Désabonnement réussi !',
    home42: 'Cet utilisateur est très discret et n\'a pas laissé de biographie.',
    home43: 'Accueil',

    number1: 'Mon',
    number2: 'Centre personnel',
    number3: 'Portefeuille',
    number4: 'Mes favoris',
    number5: 'Mes abonnés',
    number6: 'Mes fans',
    number7: 'Historique de navigation',
    number8: 'Gestion des transactions',
    number9: 'Mes publications',
    number10: 'Mes achats',
    number11: 'Mes ventes',
    number12: 'Panier',
    number13: 'Page personnelle',
    number14: 'Service client',
    number15: 'Paramètres',
    number16: 'Ajouter une adresse',
    number17: 'Modifier une adresse',
    number18: 'Seuls les fichiers image sont autorisés!',
    number19: 'La taille du fichier ne peut pas dépasser 10Mo!',
    number20: 'Téléversement de l\'image réussi',
    number21: 'Solde',
    number22: 'Produits favoris',
    number23: 'Informations personnelles',
    number24: 'Modifier',
    number25: 'Soumettre',
    number26: 'Surnom',
    number27: 'Biographie',
    number28: 'Adresse de livraison',
    number29: 'Ajouter',
    number30: 'Par défaut',
    number31: 'Non payé',
    number32: 'En attente d\'expédition',
    number33: 'Terminé',
    number34: 'Annulé',
    number35: 'En attente de validation',
    number36: 'Accepté',
    number37: 'Rejeté',
    number38: 'Commande terminée',
    number39: 'Paiement de la commande réussi!',
    number40: 'Annulation de la commande réussie!',
    number41: 'Retrait réussi!',
    number42: 'Recharge',
    number43: 'Retrait',
    number44: 'Historique des dépenses',
    number45: 'Numéro de commande',
    number46: 'Moyen de paiement',
    number47: 'Tout',
    number48: 'Rechercher',
    number49: 'Numéro de commande',
    number50: 'Moyen de paiement',
    number51: '51 Monnaie (devrait être traduit par le nom de la monnaie si elle existe en français)',
    number52: 'État de la commande',
    number53: 'Date de création de la commande',
    number54: 'Date de mise à jour de la commande',
    number55: 'Action',
    number56: 'Payé',
    number57: 'Annuler la commande',
    number58: 'Détails',
    number59: 'Numéro',
    number60: 'Expédié',
    number61: 'En attente de traitement',
    number62: 'Historique des retraits',
    number63: 'ID utilisateur',
    number64: 'Montant du retrait',
    number65: 'État',
    number66: 'Date de création',
    number67: 'Retrait du portefeuille',
    number68: 'Retrait',
    number69: 'Détails de la commande du portefeuille',
    number70: 'Toutes les commandes',
    number71: 'En attente de paiement',
    number72: 'En attente d\'expédition',
    number73: 'Terminé',
    number74: 'Annulé',
    number75: 'Payé',
    number76: 'Tout expédié',
    number77: 'Numéro de colis',
    number78: 'Expédition réussie!',
    number79: 'Mes ventes',
    number80: 'Aucune donnée de commande',
    number81: 'Numéro de commande',
    number82: 'Heure de la commande',
    number83: 'Personne commandant',
    number84: 'Heure de modification',
    number85: 'Détails',
    number86: 'Total',
    number87: 'Expédié',
    number88: 'Détails',
    number89: 'Saisir le numéro de colis',
    number90: 'Numéro de colis',
    number91: 'Veuillez saisir le numéro de colis',
    number92: 'Annulation réussie!',
    number93: 'Succès!',
    number94: 'Réception de la commande retardée réussie!',
    number95: 'Mes achats',
    number96: 'Payer immédiatement',
    number97: 'Confirmer la réception',
    number98: 'Réception retardée',
    number99: 'Annuler la commande',
    number100: 'Vendeur',

    number101: 'Mes favoris',
    number102: 'Mes fans',
    number103: 'Mes abonnés',
    number104: 'Moyen de paiement',
    number105: '51 Monnaie',  // 假设"51币"是一种虚拟货币，可以根据实际情况调整
    number106: 'État de la commande',
    number107: 'Heure de paiement',
    number108: 'Je ai payé',
    number109: 'Paiement de la commande réussi !',
    number110: 'Tous les produits',
    number111: 'Êtes-vous sûr de vouloir supprimer le produit ?',
    number112: 'Suppression réussie !',
    number113: 'Annulation réussie !',
    number114: 'Êtes-vous sûr de vouloir mettre le produit en vente ?',
    number115: 'Êtes-vous sûr de vouloir retirer le produit de la vente ?',
    number116: 'Succès !',
    number117: 'Mettre en vente',
    number118: 'Retirer de la vente',
    number119: 'Supprimer',
    number120: 'Voir les détails',

    cart1: 'Informations sur le produit',
    cart2: 'Prix unitaire',
    cart3: 'Quantité',
    cart4: 'Total',
    cart5: 'Action',
    cart6: 'Prix unitaire',  // 重复项，假设是错误，所以未翻译第二次
    cart7: 'Êtes-vous sûr de vouloir supprimer ?',
    cart8: 'Confirmer',
    cart9: 'Annuler',
    cart10: 'Supprimer',
    cart11: 'La liste du chariot est vide',
    cart12: 'articles, total des produits',
    cart13: 'Total',
    cart14: 'Paiement',
    cart15: 'Ajouter une adresse',
    cart16: 'Telegram ou WatchApp doit être rempli.',
    cart17: 'Configuration des informations utilisateur réussie !',
    cart18: 'Veuillez sélectionner ou remplir l\'adresse de livraison !',
    cart19: 'Commande créée avec succès !',
    cart20: 'Adresse de livraison',
    cart21: 'Vous devez d\'abord ajouter une adresse de livraison pour pouvoir soumettre la commande.',
    cart22: 'Destinataire',
    cart23: 'Coordonnées',
    cart24: 'Adresse de livraison',
    cart25: 'Changer d\'adresse',
    cart26: 'Ajouter une adresse',
    cart27: 'Informations sur le produit',
    cart28: 'Prix unitaire',
    cart29: 'Quantité',
    cart30: 'Montant payé',
    cart31: 'Prix total',
    cart32: 'Détails du montant',
    cart33: 'Total à payer',
    cart34: 'Soumettre',
    cart35: 'Changer l\'adresse de livraison',
    cart36: 'Annuler',
    cart37: 'Confirmer',
    cart38: 'Informations utilisateur',
    cart39: 'Soumettre',
    cart40: 'Le nom de famille ne peut pas être vide',
    cart41: 'Le prénom ne peut pas être vide',
    cart42: 'Le numéro de téléphone ne peut pas être vide',
    cart43: 'Le pays ne peut pas être vide',
    cart44: 'La province/municipalité/région ne peut pas être vide',
    cart45: 'La ville ne peut pas être vide',
    cart46: 'L\'adresse détaillée ne peut pas être vide',
    cart47: 'Le code postal ne peut pas être vide',
    cart48: 'Adresse modifiée avec succès !',
    cart49: 'Adresse ajoutée avec succès !',
    cart50: 'Nom de famille',
    cart51: 'Prénom',
    cart52: 'Pays',
    cart53: 'Province/Municipalité/Région',
    cart54: 'Ville',
    cart55: 'Adresse détaillée',
    cart56: 'Code postal',
    cart57: 'Numéro de téléphone',
    cart58: 'Définir par défaut',
    cart59: 'Accueil',
    cart60: 'Service client',
    cart61: 'Publier',
    cart62: 'Mon',
    cart63: 'Panier',
    cart64: 'Date d\'expédition',
    cart65: 'Date de paiement',
    cart66: 'Informations de livraison',
    cart67: 'Montant payé',
    cart68: 'Livré à',
    cart69: 'Produit',
    cart70: 'Vous pouvez demander une facture',
    cart71: 'Informations de la commande',
    cart72: 'Vendeur',
    cart73: 'Soumis avec succès !',
    cart74: 'Copie réussie',
    cart75: 'Échec de la copie',
    cart76: 'Ratio',
    cart77: 'Crédit disponible',
    cart78: 'Transfert',
    cart79: 'Montant de recharge',
    cart80: 'Recharger',
    cart81: 'Catégorie',


    setup1: "Informations personnelles",
    setup2: "Mon adresse de livraison",
    setup3: "Mon profil",
    setup4: "Compte et sécurité",
    setup5: "Confidentialité",
    setup6: "Général",
    setup7: "Aide et commentaires",
    setup8: "À propos de nous",
    setup9: "Déconnexion",
    setup10: "Message de la station",
    setup11: "Aucune donnée pour le moment",
    setup12: "Ajouter au panier avec succès!",
    setup13: "Échec de l'ajout au panier!",

    setup14: "Modification du produit",
    setup15: "Version du produit",
    setup16: "Image de couverture du produit",
    setup17: "Catégorie de produit",
    setup18: "Nom du produit",
    setup19: "Prix du produit (CNY)",
    setup20: "Description du produit",
    setup21: "Photos du produit (Max 10 images)",
    setup22: "Réinitialiser",
    setup23: "Produit créé avec succès! ",


    setup24: "Stock de produits insuffisant! ",
    setup25: "Mode de paiement",
    setup26: '51coin',
    setup27: 'transfert',
    setup28: "Lien du produit ou nom/lien de l'article",
    setup29: "L'utilisateur n'est pas un vendeur et ne peut pas publier de produits! ",
    setup30: "Opération non humaine détectée! ",
    setup31: "Inventaire des produits",
    setup32: 'Vues',
    setup33: "Commande soumise avec succès!",
    setup34: "Afficher la commande",
    setup35: "Inventaire des produits",
    setup36: "La catégorie de produit ne peut pas être vide",
    setup37: "Le nom du produit ne peut pas être vide",
    setup38: "La description du produit ne peut pas être vide",
    setup39: "L'inventaire des produits ne peut pas être vide",
    setup40: "Le prix du produit ne peut pas être vide",
    setup41: "L'image de couverture ne peut pas être vide",
    setup42: "L'image du produit ne peut pas être vide",
    setup43: "Le transfert a été effectué et est en attente de confirmation",
    setup44: "Veuillez sélectionner la méthode de transfert! ",
    setup45: "Heure d'achèvement",
    setup46: 'Monnaie 51',
    setup47: "Paiem. virement",
    setup48: "Méthode de transfert",
    setup49: "Détails du produit",
    setup50: "Acheteur",
    setup51: "Les frais d'expédition du produit sont de",
    setup52: "Frais d'expédition",
    setup53: "Quantité vendue",
    setup54: "Quantité minimale d'achat",
    setup55: "Ajouter",
    setup56: "Le compte a été reçu",
    setup57: "Coordonnées du bénéficiaire",
    setup58: "Informations de contact du commerçant",
    setup59: "Coordonnées de l'acheteur",
    setup60: "Copier",
    setup61: "Populaire",
    setup62: "Remplissez au moins un champ",
    setup63: "Contactez-nous",
    setup64: "Estimation",
    setup65: " Abonnez-vous à nous ",
    setup66: "Coopération entre célébrités d'Internet à l'étranger",
    setup67: "Problèmes de paiement et de service après-vente",
    setup68: "Dividendes des utilisateurs",

    setup69: "Type de devise",
    setup70: "Taux de change",
    setup71: "Frais de traitement",
    setup72: "Reçu réel",
    setup73: "Montant minimum de retrait",
    setup74: "Devise",
    setup75: "Frais de traitement",
    setup76: "Reçu réel",

    setup78: "Code d'invitation",
    setup79: "Veuillez saisir le code d'invitation",
    setup80: "L'indicatif régional mobile ne peut pas être vide",
    setup81: "Indicatif régional",
    setup82: "Annuler l'heure",
    setup83: "Détails du retrait",
    setup84: "Détails des dividendes",
    setup85: "Est-ce expiré?",
    setup86: "Utiliser",
    setup87: "Non expiré",
    setup88: "Expiré",
    setup89: "Non utilisé",
    setup90: "Déjà utilisé",
    setup91: "Partiellement utilisé",
    setup92: "remise",
    setup93: "Remise utilisée",
    setup94: "Remise restante",
    setup95: "Utiliser",
    setup96: "Est-ce expiré?",
    setup97: "Délai d'expiration",
    setup98: "Heure de remise",
    setup99: "Partage d'alliance",
    setup100: "Annuler le paiement",
    setup101: "Fermer l'interface",
    setup102: "Paiement USDT",
    setup103: "Montant eff.",
    setup104: "Montant de la transaction de la commande",
    setup105: "Réseau",
    setup106: "Vous payez pour le réseau",
    setup107: "Paiement réussi",
    setup108: "Adresse du portefeuille du bénéficiaire",
    setup109: "Veuillez vérifier attentivement que le montant réel du paiement correspond à celui que vous avez transféré. En cas d'erreur, vous en assumerez les conséquences.",
    setup110: "Délai d'expiration",
    setup111: "En attente de paiement",
    setup112: "Paiement réussi",
    setup113: "Commande expirée",
    setup114: "Vérifier les transactions de la blockchain",
    setup115: "",
    setup116: "",
    setup117: "",
    setup118: "",
    setup119: "",

    setup130: "À propos de nous",
    setup131: "Lié à la livraison",
    setup132: "Autre",
    setup133: "Politique d'expédition",
    setup134: "Heure de livraison/ramassage du colis",
    setup135: "Conditions d'utilisation",
    setup136: "Mode de paiement",
    setup137: "Politique de retour",
    setup138: "Politique de confidentialité",
    setup139: "Space Network Technology Co., Ltd.",
    setup140: "Heures de travail:",
    setup141: "Personne à contacter:",
    setup142: "E-mail de l'entreprise:",
    setup143: "Code postal:",
    setup144: "Adresse:",

    setup0140: "Du lundi au vendredi (9h00-18h00)",
    setup0141: "M. Liang",
    setup0143: "999077",
    setup0144: "Salle 341, 3e étage, bâtiment industriel public, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",

    setup145: "Contrat international d'expédition de colis",
    setup146: "En raison des particularités du transport international, vous devez respecter les règles relatives au transport international de colis. Veuillez lire attentivement et accepter les conditions générales suivantes.",
    setup147: "Norme de compensation du package:",
    setup148: "Si vos produits sont perdus, manquants, endommagés, retardés ou retenus par les douanes pendant le transport pour des raisons indépendantes de la volonté de 51shopy, 51shopy ne sera pas tenu de verser d'indemnisation. Nous déclinons également toute responsabilité en cas de perte de bénéfices indirecte et non réalisée. Pour plus de détails, veuillez consulter la section 'Assurance et indemnisation des colis'.",
    setup149: "51shopy n'est pas responsable de l'indemnisation dans les cas suivants (pour les colis non assurés):",
    setup150: "1. Aucune compensation ne sera accordée en cas de perte de courrier causée par un cas de force majeure tel qu'une catastrophe naturelle ou des raisons douanières;",
    setup151: "2. Si les envois postaux enfreignent les interdictions ou les restrictions, les autorités compétentes les confisqueront ou les traiteront conformément aux lois et règlements en vigueur, sans indemnisation;",
    setup152: "3. Lors de l'envoi d'un colis, si le colis est emballé en bon état, ne présente aucun signe de démontage et n'a pas perdu de poids, mais que les pièces internes sont manquantes ou endommagées, aucune indemnisation ne sera accordée;",
    setup153: "4. Si le suivi du courrier indique que le colis n'a pas été livré normalement et que l'entreprise de logistique confirme que le colis a été confisqué par les douanes, l'enquête de l'entreprise de logistique prévaudra et aucune indemnisation ne sera accordée;",
    setup154: "5. Aucune compensation ne sera accordée si le courrier est perdu ou si le contenu est manquant en raison de la faute du client ou du courrier lui-même;",
    setup155: "6. Si le client ne fait pas de demande de renseignements et ne dépose pas de réclamation entre la date de réception du courrier électronique et l'expiration du délai de demande de renseignements, aucune indemnisation ne sera versée;",
    setup156: "7. Si le courrier international est retenu, confisqué ou détruit par le pays de destination conformément à ses lois nationales, aucune indemnisation ne sera versée.",
    setup157: "Articles interdits",
    setup158: "Conformément à la réglementation de notre pays sur les articles interdits et restreints:",
    setup159: "1. Se conformer à l'annonce du Bureau national des postes, du ministère de la Sécurité publique et du ministère de la Sécurité d'État concernant la publication du 'Règlement sur la gestion des articles interdits'.",
    setup160: "2. Se conformer aux dispositions de l'ordonnance n°43 de l'Administration générale des douanes (Liste des articles interdits et restreints à l'importation et à l'exportation de la République populaire de Chine).",
    setup161: "Articles qui ne peuvent pas être expédiés par courrier",
    setup162: "1. Articles dont la circulation et le transport sont interdits conformément aux lois nationales.",
    setup163: "2. Marchandises dangereuses explosives, inflammables, corrosives, radioactives ou toxiques.",
    setup164: "3. Publications, livres, documents ou articles contenant du contenu réactionnaire ou obscène.",
    setup165: "4. Diverses devises.",
    setup166: "5. Articles qui portent atteinte à la santé publique.",
    setup167: "6. Articles périssables.",
    setup168: "7. Animaux vivants (à l'exception des abeilles, des vers à soie et des sangsues, à condition que l'emballage garantisse la sécurité des travailleurs).",
    setup169: "8. Un emballage inadéquat peut présenter un danger pour les travailleurs ou contaminer ou endommager d'autres articles emballés.",
    setup170: "9. Autres éléments non adaptés à l'envoi postal.",
    setup171: "Articles interdits à la livraison selon les pratiques postales",
    setup172: "1. Articles dont la qualité ou l'emballage peuvent nuire aux employés des postes ou contaminer/endommager d'autres colis ou équipements postaux.",
    setup173: "2. Articles munis de scellés métalliques ou d'autres bords tranchants susceptibles de gêner le traitement postal.",
    setup174: "3. Divers types d'armes à feu, de munitions, de matières ou de contenants explosifs, inflammables, corrosifs ou radioactifs, de poisons puissants, de stupéfiants, de produits biochimiques et de matières infectieuses.",
    setup175: "4. Toute publication, tout matériel de propagande ou tout document imprimé susceptible de mettre en danger la sécurité et la stabilité sociales ou de contenir des contenus obscènes.",
    setup176: "5. Divers éléments pouvant mettre en danger la santé publique.",
    setup177: "6. Documents ou articles qui ne sont pas acceptés ou autorisés à circuler dans le pays de réception.",
    setup178: "Modes de paiement disponibles",
    setup179: "Le site Web prend en charge plusieurs méthodes de paiement, notamment les cartes de crédit/débit, WeChat, Alipay, etc. Si vous devez effectuer des paiements fréquents ou des prélèvements, vous pouvez également utiliser le solde pour payer.",
    setup180: "- Si un remboursement est effectué pour un bon de commande par carte de crédit/débit, il sera remboursé sur le compte d'origine; le remboursement pour la recharge du solde sera également remboursé sur le compte d'origine",
    setup181: "- Si un remboursement intervient pour des paiements de commande effectués via WeChat, Alipay, etc., le remboursement sera reversé sur le compte d'origine;",
    setup182: "- Si un remboursement intervient pour le paiement du solde, il sera remboursé sur le solde du compte;",
    setup183: "Politique de confidentialité des utilisateurs de 51shopy",
    setup184: "La sécurité de vos informations personnelles est notre priorité et nous apprécions votre confiance. Nous ne vendrons ni ne divulguerons en aucun cas vos informations personnelles à des tiers. Nous protégerons la sécurité et la confidentialité des informations personnelles que vous nous fournissez et les utiliserons uniquement comme décrit ici. Pour toute question, suggestion ou commentaire concernant cette politique de confidentialité, vous pouvez nous contacter à tout moment via le service client en ligne de 51shopy ou le compte de service officiel de 51shopy.",
    setup185: "Cette politique ne s'applique pas aux services qui vous sont fournis par des tiers, ni aux services pour lesquels nous avons défini des politiques de confidentialité de manière indépendante.",
    setup186: "Veuillez lire attentivement et comprendre cette politique avant d'utiliser les services de 51shopy. Votre acceptation de cette politique de confidentialité signifie que vous avez compris les fonctionnalités offertes par cette application et les informations personnelles nécessaires à leur exécution.",
    setup187: "Les droits de propriété et d'exploitation des services d'utilisateurs enregistrés concernés appartiennent à ",
    setup188: "1. Quelles informations personnelles collectons-nous?",
    setup189: "Vous pouvez utiliser ou visiter notre site web sans divulguer d'informations personnelles ni de transactions vous concernant, mais vous devez créer un compte pour bénéficier de l'intégralité de nos services. En nous fournissant vos informations, vous acceptez leur transfert et leur stockage sur nos serveurs.",
    setup190: "51shopy collecte les informations personnelles que vous fournissez lorsque vous utilisez le site web, notamment votre nom, vos coordonnées, votre adresse e-mail, votre nom de compte 51shopy et votre mot de passe, ainsi que d'autres informations nécessaires à la création de votre compte. Outre les informations personnelles que nous pouvons collecter et traiter lors de l'inscription, nous collectons, stockons et traitons également les informations suivantes concernant nos utilisateurs sur 51shopy:",
    setup191: "1) Informations d'achat",
    setup192: "2) Informations sur le compte de service",
    setup193: "3) Informations de paiement (heure de paiement, montant du paiement, canal de paiement, etc.)",
    setup194: "4) Rechercher des informations sur l'historique de navigation (contenu de recherche, comportement de clic sur les liens, historique de navigation, historique d'affichage des clics, etc.)",
    setup195: "5) Cookies et autres informations informatiques",
    setup196: "Nous avons collaboré avec Microsoft Clarity et Microsoft Advertising pour analyser votre utilisation et vos interactions avec notre site web grâce à des indicateurs comportementaux, des cartes thermiques et des rediffusions de session, afin d'améliorer et de commercialiser nos produits et services. Les données d'utilisation du site sont collectées à l'aide de cookies internes et tiers, ainsi que d'autres technologies de suivi, afin de déterminer la popularité des produits et services et des activités en ligne. De plus, nous utilisons ces informations à des fins d'optimisation du site, de lutte contre la fraude et la sécurité, et de publicité. Pour plus d'informations sur la manière dont Microsoft collecte et utilise vos données, veuillez consulter:",
    setup197: "Déclaration de confidentialité Microsoft",
    setup198: "2. Comment utilisons-nous vos informations personnelles?",
    setup199: "Nous ne vendrons ni ne divulguerons les informations personnelles des utilisateurs et nous nous efforçons de protéger vos informations et votre vie privée. Nous utiliserons vos informations pour vous fournir de meilleurs services, notamment:",
    setup200: "1) Vous contacter par e-mail et vous fournir une série de nos services, notamment des services de conseil, des services d'information sur les commandes, des services d'information sur les colis, des services après-vente de produits, etc.",
    setup201: "2) Vous communiquer les activités de la plateforme par courrier électronique, courrier interne, etc., notamment en vous fournissant des coupons, des remises sur les frais d'expédition et des promotions spéciales, et en vous offrant la possibilité d'utiliser des services tiers.",
    setup202: "3) Lorsque vous recherchez et parcourez les liens de nos partenaires marchands sur 51shopy, votre identifiant 51shopy, vos comportements et informations associés (contenu de recherche, comportement de clic sur le lien, historique de navigation, historique de consultation des clics, etc.) seront transmis à la source du lien correspondant, afin que nous et nos partenaires marchands puissions collaborer pour vous fournir des services performants et de qualité. Vous pouvez cliquer pour consulter les partenaires marchands de 51shopy (www.taobao.com, www.1688.com).",
    setup203: "Conformément aux lois, réglementations et normes nationales, dans les circonstances suivantes, les partenaires n’ont pas besoin de votre autorisation ou de votre consentement pour utiliser, transférer ou divulguer vos informations personnelles:",
    setup204: " 1) Conformément aux exigences impératives des lois, règlements, organes administratifs et judiciaires et autres obligations légales ; ",
    setup205: "2) Dans la mesure permise par les lois et règlements, il est nécessaire de protéger l'intérêt public, la sécurité des biens et de vous protéger, ainsi que les autres utilisateurs de 51shopy, 51shopy, les sociétés affiliées ou les partenaires de 51shopy, contre les dommages;",
    setup206: "3) Nécessaire pour réaliser les fonctions principales de nos produits et/ou services, ou pour fournir les services dont vous avez besoin;",
    setup207: "4) Traiter vos informations personnelles divulguées par vous ou d'autres informations personnelles qui ont été légalement divulguées (telles que les informations personnelles légalement divulguées par le biais de rapports d'actualité juridiques, de divulgation d'informations gouvernementales ou d'autres canaux) dans une mesure raisonnable;",
    setup208: "5) Gérez les conflits ou les controverses entre vous et les autres selon vos besoins;",
    setup209: "6) Respecter les accords pertinents signés avec vous (y compris les accords électroniques en ligne et les règles de plateforme correspondantes) ou d'autres documents juridiques;",
    setup210: "7) Utilisation fondée sur l'intérêt public social et les urgences de santé publique et dans le respect des lois et réglementations.",
    setup211: "Aux fins susmentionnées, vous avez également le droit de résilier cette notification à tout moment. Vous pouvez vous connecter au site web 51shopy et le configurer vous-même dans la fonction personnalisée.",
    setup212: "Veuillez noter que nous ne partagerons pas vos données personnelles avec des annonceurs sans votre consentement. Nous ne demanderons ni ne communiquerons aucune information personnelle à des enfants ou à d'autres personnes incapables sans le consentement, la connaissance et la présence de leurs tuteurs.",
    setup213: "Par la présente, vous reconnaissez, partagez et transférez des informations personnelles anonymisées, et garantissez que le destinataire des données ne peut pas restaurer ni réidentifier la personne concernée, ce qui ne constitue pas un partage, un transfert ni une divulgation publique d'informations personnelles à l'extérieur. Le stockage et le traitement de ces données ne nécessitent ni notification ni consentement.",
    setup214: "Nous pouvons confier le traitement de vos informations personnelles à des partenaires autorisés afin qu'ils puissent vous fournir certains services ou exécuter certaines fonctions en notre nom. Nous confierons le traitement de vos informations uniquement aux fins légitimes, appropriées, nécessaires, spécifiques et claires énoncées dans la présente politique, et les partenaires autorisés ne pourront accéder qu'aux informations nécessaires à l'exercice de leurs fonctions. 51shopy ne communiquera pas votre adresse e-mail, votre nom de compte et votre mot de passe sur le site web 51shopy, vos coordonnées ni aucune autre information privée à nos partenaires.",
    setup215: "3. Combien de temps conserverons-nous vos informations?",
    setup216: "Une fois votre compte 51shopy créé, nous enregistrerons définitivement vos informations personnelles. Si vous souhaitez annuler votre compte ou supprimer vos informations personnelles, veuillez contacter le service client en ligne.",
    setup217: "En vertu du RGPD, les responsables du traitement et les sous-traitants sont tenus de restituer ou de supprimer toutes les données personnelles après la fin du service ou l'expiration du contrat ou de l'accord, sauf s'il existe une obligation légale de conserver les données.",
    setup218: "4. Comment protégeons-nous vos informations personnelles",
    setup219: "Nous prendrons toutes les mesures raisonnables et réalisables pour protéger vos informations personnelles. Nous veillerons à ce qu'aucune information personnelle non pertinente ne soit collectée.",
    setup220: "5. Mise à jour de la politique",
    setup221: "Afin de vous offrir une meilleure expérience produit et service, nous travaillons constamment à l'amélioration de nos produits, services et technologies. Lorsque de nouveaux services et processus métier évoluent, nous pouvons mettre à jour notre politique de confidentialité pour vous informer des modifications spécifiques. Veuillez consulter régulièrement cette page et suivre la politique la plus récente. Une fois publiée, elle sera contraignante pour vous.",
    setup222: "6. Contactez-nous",
    setup223: "Si vous avez des questions concernant cette déclaration de confidentialité, veuillez contacter:",
    setup224: "Veuillez lire attentivement les Conditions d'utilisation de 51shopy avant de vous inscrire et assurez-vous de bien les comprendre. Veuillez lire attentivement et choisir d'accepter ou de refuser les Conditions d'utilisation de 51shopy, en particulier les clauses d'exonération ou de limitation de responsabilité, la loi applicable et le règlement des litiges. Sans acceptation des présentes Conditions d'utilisation de 51shopy, vous n'avez aucun droit de vous inscrire, de vous connecter ou d'utiliser les services de 51shopy. Votre inscription, votre connexion et votre utilisation seront considérées comme votre acceptation des Conditions d'utilisation de 51shopy et votre consentement à les respecter.",
    setup225: "Les Conditions d’utilisation de 51shopy stipulent vos droits et obligations, ainsi que ceux de 51shopy, concernant les services 51shopy (ci-après dénommés 'Services'). Les Conditions d’utilisation de 51shopy peuvent être mises à jour par 51shopy à tout moment. Les Conditions d’utilisation de 51shopy mises à jour remplaceront les conditions d’origine une fois publiées et rendues publiques, sans préavis. Vous pouvez consulter la dernière version des Conditions d’utilisation de 51shopy sur la plateforme 51shopy. Il est également recommandé de se tenir informé des Conditions d’utilisation mises à jour afin d’éviter tout malentendu et tout litige. Après la modification des Conditions d’utilisation de 51shopy, si vous n’acceptez pas les conditions modifiées, veuillez cesser immédiatement d’utiliser les services fournis par 51shopy. Votre utilisation continue des services fournis par 51shopy sera considérée comme une acceptation des Conditions d’utilisation de 51shopy modifiées.",
    setup226: "1. Champ d'application des présentes Conditions d'utilisation",
    setup227: "Les droits de propriété et d'exploitation des services d'utilisateurs enregistrés concernés appartiennent à Space Network Technology . Les services fournis doivent être mis en œuvre conformément aux règles, conditions et spécifications de service émises par 51shopy, ce qui signifie également que les utilisateurs concernés ont conclu un accord avec 51shopy et accepté toutes ses conditions de service.",
    setup228: "2. Collecte et utilisation des informations",
    setup229: "Lorsque vous utilisez les services de 51shopy, nous pouvons être amenés à collecter et à utiliser les deux types d'informations personnelles suivants:",
    setup230: "1. Afin de vous fournir les fonctionnalités de base de nos services, vous devez nous autoriser à collecter et à utiliser les informations nécessaires. Si vous refusez de fournir ces informations, vous ne pourrez pas vous inscrire, vous connecter ni utiliser nos services normalement;",
    setup231: "2. Afin de vous offrir des fonctionnalités supplémentaires de nos services, vous pouvez accepter ou refuser les informations que nous collectons et utilisons. Si vous refusez de les fournir, vous ne pourrez pas utiliser les fonctionnalités supplémentaires concernées ni obtenir les effets fonctionnels escomptés, et cela n'affectera pas votre utilisation de nos fonctionnalités de base.",
    setup232: "Nous protégeons votre droit de savoir et votre droit de choisir lors de l'installation ou de l'utilisation, conformément à la loi. Lorsque vous utilisez les services 51shopy, les services impliquant des fonctions disponibles sur votre appareil nécessitent votre consentement préalable. Après votre confirmation, 51shopy se réserve le droit d'activer les fonctions auxiliaires nécessaires, telles que la collecte de la localisation géographique, la consultation du carnet d'adresses, l'utilisation de l'appareil photo et l'activation des services d'enregistrement.",
    setup233: "Les informations collectées et utilisées incluent, sans s'y limiter, le nom de l'utilisateur, ses coordonnées et d'autres informations de base. L'utilisateur accepte que l'utilisation de ces informations soit soumise aux dispositions de l'article3 'Protection des informations de l'utilisateur'.",
    setup234: "3. Protection des informations utilisateur",
    setup235: "Nous ne divulguerons ni ne révélerons vos informations personnelles à des tiers, sauf si:",
    setup236: "1. Partage nécessaire pour remplir des obligations légales;",
    setup237: "2. Partage avec votre consentement;",
    setup238: "4. Droits et obligations de l'utilisateur",
    setup239: "1. Vous avez le droit de vous connecter au site Web 51shopy pour consulter, corriger et compléter vos informations personnelles.",
    setup240: "2. Vous avez le droit de contacter le service client en ligne pour résilier votre compte. Après la résiliation, nous cesserons de vous fournir des services et supprimerons ou anonymiserons vos informations personnelles conformément aux exigences de la législation en vigueur.",
    setup241: "3. Dans certaines fonctions commerciales, nous pouvons prendre des décisions fondées uniquement sur des mécanismes décisionnels automatisés non humains, y compris des algorithmes. Si ces décisions affectent vos droits, vous pouvez nous contacter via le service client.",
    setup242: "4. Toutes les informations que vous fournissez à 51shopy doivent être vraies, exactes et non trompeuses.",
    setup243: "Vous comprenez et acceptez que vous êtes tenu de maintenir l'authenticité et la validité des informations que vous fournissez.",
    setup244: "5. Vous ne pouvez pas utiliser votre compte enregistré ou les services 51shopy pour créer, télécharger, copier, publier ou diffuser du contenu qui interfère avec le fonctionnement normal de 51shopy ou qui porte atteinte aux droits et intérêts légitimes d'autres utilisateurs ou de tiers.",
    setup245: "6. Vous ne pouvez pas copier, plagier, vendre, revendre ou utiliser à d'autres fins commerciales toute partie du service 51shopy ou le contenu utilisé ou obtenu via le service 51shopy.",
    setup246: "7. Vous êtes seul responsable de l'authenticité, de la légalité, de l'exactitude et de la validité de toute information transmise via votre compte 51shopy ou les services 51shopy. Toute responsabilité légale liée aux informations que vous transmettez est à votre charge et n'a aucun lien avec 51shopy. Vous devrez indemniser 51shopy ou tout tiers pour toute perte subie, et 51shopy se réserve le droit de tenir les utilisateurs concernés responsables.",
    setup247: "8. Vous serez entièrement responsable des conséquences de toutes les actions entreprises sous votre compte (y compris, mais sans s'y limiter, la signature de divers accords en ligne, la publication d'informations, l'achat de biens et de services et la divulgation d'informations).",
    setup248: "5. Stockage des informations",
    setup249: "51shopy' n'impose aucune limite quant à la quantité d'informations transmises.Nous avons pris des mesures de sécurité raisonnables et réalisables, conformes aux normes du secteur, pour protéger vos informations et empêcher leur accès, leur divulgation, leur utilisation, leur modification, leur altération ou leur perte sans autorisation.Veuillez également protéger vos informations personnelles et ne les communiquer à des tiers qu'en cas de nécessité. Ne faites pas confiance à d'autres outils de trading pour éviter le vol d'informations, voire la fraude en ligne.",
    setup250: "6. Clause de non-responsabilité",
    setup251: " 1.51shopy fera de son mieux pour restituer la situation réelle des informations sur le produit fournies, mais en raison de l'influence de divers facteurs tels que l'environnement, l'angle de prise de vue, les différences d'équipement, etc. pendant le processus de prise de vue du produit, nous ne pouvons pas garantir que le produit est exactement le même que le produit réel. ",
    setup252: "2.51shopy achète les produits désignés sur la plateforme indiquée par l'utilisateur. Si la plateforme que vous avez indiquée est en rupture de stock, si le prix change, si la livraison est retardée, si le produit réel ne correspond pas aux informations sur le site web, si le produit est anormal ou si d'autres cas de force majeure empêchent l'achat normal, nous vous en informerons à temps. Par conséquent, '51shopy' décline toute responsabilité pour les pertes que vous pourriez subir.",
    setup253: "3. Si les produits que vous avez achetés chez 51shopy présentent des problèmes après-vente (rupture de stock, dommages, défauts, etc.), nous les traiterons dans les meilleurs délais.",
    setup254: "4. 51shopy décline toute responsabilité quant aux pertes ou conséquences causées par la divulgation proactive de votre compte 51shopy ou par des attaques, fraudes, etc. de tiers. Vous devez demander réparation au contrevenant par voie de justice ou par d'autres moyens.",
    setup255: "7. Comportement interdit",
    setup256: "Vous ne pouvez pas utiliser les services 51shopy pour les activités suivantes:",
    setup257: "(1) Violation de toute loi, statut, décret ou règlement.",
    setup258: "(2) Les transactions suivantes sont impliquées:",
    setup259: "(a) les stupéfiants, les stéroïdes, certains médicaments contrôlés ou d’autres produits qui peuvent mettre en danger la sécurité des consommateurs;",
    setup260: "(b) accessoires de consommation de drogue;",
    setup261: "(c) Cigarettes;",
    setup262: "(d) du cannabis ou d’autres plantes psychoactives non autorisés;",
    setup263: "(e) nutrition, vitamines, suppléments, herbes et produits de santé naturels par abonnement;",
    setup264: "(f) tout matériel qui incite, incite, aide ou dirige d’autres personnes à se livrer à des activités illégales;",
    setup265: "(g) les objets volés, y compris les objets numériques et virtuels;",
    setup266: "(h) les documents qui incitent à la haine, à la violence, au racisme ou à d’autres formes de sectarisme ou qui exploitent des activités criminelles;",
    setup267: "(i) considéré comme obscène;",
    setup268: "(j) tout matériel qui enfreint ou viole le droit d'auteur, la marque déposée, la publicité ou la vie privée ou tout autre droit de propriété en vertu des lois de toute juridiction;",
    setup269: "(k) certains contenus ou services pornographiques;",
    setup270: "(l) des munitions, des armes ou certaines pièces ou accessoires d'armes, ou",
    setup271: "(m) Certaines armes ou couteaux réglementés par la loi applicable.",
    setup272: "(3)Relatif aux transactions suivantes:",
    setup273: "(a) Divulgation d'informations personnelles de tiers en violation des lois applicables;",
    setup274: "(b) prend en charge les systèmes pyramidaux, les systèmes de Ponzi, les systèmes matriciels, d'autres systèmes permettant de s'enrichir rapidement ou certains systèmes de downline à plusieurs niveaux;",
    setup275: "(c) les transactions liées à l'achat de rentes ou de contrats de loterie, aux systèmes d'achat de dépôts prépayés, aux opérations bancaires offshore ou aux transactions visant à financer ou à refinancer des dettes de carte de crédit;",
    setup276: "(d) vendre quelque chose avant que le vendeur n'en ait le contrôle ou la possession;",
    setup277: "(e) les processeurs de paiement collectent les paiements pour le compte des commerçants;",
    setup278: "(f) dans le cadre de la vente de chèques de voyage ou de mandats;",
    setup279: "(g) impliquant des opérations de change ou d'encaissement de chèques;",
    setup280: "(h) implique certains services de réparation de crédit ou de règlement de dettes, des transactions par carte de crédit ou des activités d'assurance, ou",
    setup281: "(i) implique d'effectuer ou de recevoir des paiements liés à la corruption ou à des pots-de-vin.",
    setup282: "(4) Impliquant la vente de produits ou de services que les agences gouvernementales ont déterminé comme pouvant être frauduleux.",
    setup283: " Vous assumerez la responsabilité légale de votre utilisation des services 51shopy, y compris, mais sans s'y limiter, l'indemnisation des pertes subies par la partie lésée. Après que 51shopy ait assumé la responsabilité légale, telle que des sanctions administratives ou une indemnisation pour violation causée par le comportement de l'utilisateur, vous devrez payer à 51shopy un montant égal d'indemnisation et des autres pertes subies par 51shopy en conséquence. ",
    setup284: "8. Responsabilité en matière d'indemnisation",
    setup285: "1. Si vos actions entraînent des pertes pour 51shopy et/ou ses filiales (y compris des pertes économiques directes, une perte de clientèle et des pertes économiques indirectes telles que des indemnisations, des règlements, des honoraires d'avocat, une assurance de conservation, des frais de litige, etc.), vous devrez indemniser 51shopy et/ou ses filiales pour toutes les pertes.",
    setup286: "2. Si vos actions entraînent des poursuites contre 51shopy et/ou ses sociétés affiliées par un tiers (y compris, mais sans s'y limiter, les vendeurs sur Taobao, 1688 et d'autres plateformes), 51shopy et/ou ses sociétés affiliées pourront recouvrer toutes leurs pertes auprès de vous après avoir assumé des obligations telles qu'une compensation financière envers le tiers.",
    setup287: "9. Loi applicable et juridiction",
    setup288: "1. Le présent Contrat de service et tout autre contrat distinct par lequel nous vous fournissons des services seront régis et interprétés conformément aux lois de Hong Kong.",
    setup289: "2. Tout litige découlant de votre utilisation des services 51shopy et tout litige lié à ces services seront résolus par voie de négociation entre 51shopy et vous. En cas d'échec de la négociation, chaque partie pourra intenter une action en justice devant le tribunal compétent du lieu de signature du présent accord.",
    setup290: "Voici le calendrier de sortie de l'entrepôt (envoi à l'entrepôt du prestataire logistique) / de collecte du prestataire logistique, à titre indicatif uniquement (le calendrier réel est soumis aux dispositions de chaque prestataire logistique):",
    setup291: "Heure de livraison/ramassage du colis:",
    setup292: "Lorsque le statut du colis dans l'entrepôt 51shopy est 'Emballé', l'entrepôt et la société de logistique organiseront la livraison/le retrait dans un délai déterminé (la société de logistique est fermée les week-ends et jours fériés, et le retrait sera reporté).",
    setup293: "Route",
    setup294: "Calendrier d'envoi/de ramassage (heure de Pékin)",
    setup295: "GD-EMS",
    setup296: "Retrait du lundi au dimanche",
    setup297: "GD-EUB",
    setup298: "Retrait du lundi au dimanche",
    setup299: "GD-E-EMS",
    setup300: "Retrait du lundi au dimanche",
    setup301: "EUB-T",
    setup302: "Retrait du lundi au dimanche",
    setup303: "DHL Express",
    setup304: "Retrait du lundi au samedi",
    setup305: "DHL Heavy Cargo Standard Express",
    setup306: "Retrait du lundi au samedi",
    setup307: "Ligne spéciale DHL européenne",
    setup308: "Expédition du lundi au dimanche (livrée à l'entrepôt du prestataire logistique)",
    setup309: "Ligne américaine (petite)",
    setup310: "Expédition du lundi au dimanche (livrée à l'entrepôt du prestataire logistique)",
    setup311: "Ligne britannique (petite)",
    setup312: "Expédition du lundi au dimanche (livrée à l'entrepôt du prestataire logistique)",
    setup313: "Corée EMS",
    setup314: "Expédition depuis notre entrepôt tous les jours",
    setup315: "Paquet postal PDB",
    setup316: "Haibao",
    setup317: "Chemins de fer européens",
    setup318: "United Parcel Service Hong Kong Limited",
    setup319: "Ligne dédiée Aramex",
    setup320: "SAL",
    setup331: "EMS",
    setup332: "PD-EUB",
    setup333: "Ligne britannique",
    setup334: "NH-EMS",
    setup335: "Ligne hors taxes européenne",
    setup336: "Ligne américaine",
    setup337: "YTO Express",
    setup338: "SF Express",
    setup339: "51shopy est une plateforme proposant des services d'achat et de livraison de produits chinois. Elle propose aux utilisateurs des services de recherche d'informations sur les produits, d'achat et de livraison. Durant cette période, 51shopy assure des services d'inspection de base des produits, de confirmation des communications avec les commerçants et un service après-vente afin de protéger vos droits et intérêts légaux et de garantir votre expérience d'achat.",
    setup340: "Si vous constatez que les produits achetés sont contrefaits ou de qualité inférieure, veuillez contacter notre service client ou envoyer un e-mail à",
    setup341: "1. Réception et inspection: après vérification de la qualité du produit et dépôt dans l'entrepôt 51shopy, ou après réception du colis, si vous constatez des problèmes de qualité ou si vous doutez de son authenticité, veuillez contacter le service client dans les plus brefs délais et fournir les preuves pertinentes.",
    setup342: "2. Documents de réclamation: Fournissez le bon de commande, le reçu de paiement, la description du produit et la preuve de produits contrefaits ou de qualité inférieure.",
    setup343: "3. Après avoir reçu votre réclamation, notre service client analysera les détails avec vous et vous aidera à communiquer avec le vendeur pour résoudre le problème et s'efforcera de défendre vos droits.",
    setup344: "Veuillez noter qu'en raison de l'authenticité du produit, une évaluation professionnelle et des procédures juridiques supplémentaires peuvent être nécessaires. Si une évaluation par un organisme professionnel est requise, les frais d'évaluation seront à votre charge. Afin de protéger les droits et les intérêts de toutes les parties, nous vous recommandons de privilégier les canaux officiels et les vendeurs réputés lors de vos achats afin de réduire le risque d'achat de contrefaçons.",
    setup345: "Qu'est-ce que la garantie de retour/échange de 14 jours?",
    setup346: "La garantie de retour et d'échange de cinq jours est un service après-vente spécial (incluant le service lui-même et l'assistance technique) proposé aux consommateurs par les vendeurs de plateformes tierces. Dans les sept jours suivant la signature de la réception des marchandises (soit dans les cinq jours suivant leur mise en stock), les acheteurs peuvent retourner ou échanger les marchandises achetées conformément à cette règle et aux règles applicables émises par la plateforme tierce.",
    setup347: "Comment déterminer si un produit est éligible à la garantie de retour/échange?",
    setup348: "Les produits sont soit 'éligibles' au service de retour et d'échange gratuit de 14 jours, soit 'non éligibles' au service de retour et d'échange gratuit de 14 jours",
    setup349: "Est-il disponible?",
    setup350: "Type",
    setup351: "Par exemple",
    setup352: "Non disponible",
    setup353: "Déterminé en fonction des informations fournies par le commerçant. Si nous ne pouvons pas confirmer, nous négocierons avec le vendeur le retour/l'échange, mais le résultat final dépend de la décision du vendeur.",
    setup354: "Personnalisation",
    setup355: "Produits de conception personnalisés",
    setup356: "Ne prend explicitement pas en charge les retours et les échanges",
    setup357: "Promouvoir les produits défectueux",
    setup358: "Produits dont l'emballage, les étiquettes et les accessoires ont été retirés à la demande de l'utilisateur",
    setup359: "L'étiquette du vêtement est arrachée",
    setup360: "Journaux et périodiques",
    setup361: "Livres et revues souscrits",
    setup362: "Produits d'occasion",
    setup363: "Produits hors de Chine continentale",
    setup364: "Produits achetés à l'étranger, à Hong Kong et à Macao",
    setup365: "Sous-vêtements",
    setup366: "Sous-vêtements, chaussettes, leggings",
    setup367: "Produits pour adultes",
    setup368: "Autres questions précisées par le vendeur",
    setup369: "Respecter les règles du vendeur",
    setup370: "Nourriture",
    setup371: "Biscuits, bonbons, etc.",
    setup372: "Livres (≥15 livres)",
    setup373: "Pas moins de 15 livres",
    setup374: "Articles qui ont été ouverts et qui doivent répondre aux 'normes spéciales' pour l'emballage de retour.",
    setup375: "Pour les produits d'étanchéité, veuillez vous référer au tableau ci-joint",
    setup376: "Disponible",
    setup377: "Pour les demandes de retour/échange soumises dans les 14 jours suivant la réception, nous les traiterons conformément aux procédures standard.",
    setup378: "Lorsque le produit répond à toutes les exigences suivantes:",
    setup379: "1. Le vendeur fournit une garantie de retour;",
    setup380: "2. Dans un état revendable tel que requis par le vendeur;",
    setup381: "3. La durée de stockage ne dépasse pas 14 jours.",
    setup382: "Pour les produits avec livraison gratuite, les frais de port sont à votre charge lors du retour. Pour les produits sans livraison gratuite, les frais de port sont à votre charge lors de l'envoi du produit à notre entrepôt et lors du retour.",
    setup383: "Comment demander un service de retour/échange",
    setup384: "Dans les 14 jours suivant le passage du statut de la commande à 'Stock' (calculé à partir de l'heure suivant le passage à 'Stock', 14 jours = 336 heures), vous pouvez demander un service de retour et d'échange sur la page. Les demandes pourraient ne plus être acceptées après ce délai.",
    setup385: "Précautions et FAQ",
    setup386: "Remarques:",
    setup387: "Le montant total du remboursement/échange est basé sur le prix réel du produit que vous avez payé",
    setup388: "Nous ne pouvons retourner/échanger des produits pour vous que si le vendeur est d'accord",
    setup389: "Après avoir demandé un service de retour/échange, assurez-vous que le solde de votre compte est suffisant pour payer les frais de retour et de service.",
    setup390: "Veuillez consulter le tableau ci-dessous pour connaître les exigences d'emballage de retour de certains produits. Si ces exigences ne sont pas respectées, vous ne pourrez pas retourner/échanger le produit.",
    setup391: "Normes spéciales",
    setup392: "Catégorie de produit",
    setup393: "Normes spéciales",
    setup394: "Nouvelles chaussures de sport",
    setup395: "Les fermoirs antivol (le cas échéant) et les autocollants anti-effraction n'ont pas été coupés/retirés et sont entièrement fonctionnels.",
    setup396: "Détergent / Tampon / Papier / Parfum",
    setup397: "Les contenants scellés à usage unique pour les produits de soins personnels, le cas échéant, doivent rester scellés.",
    setup398: "Soins capillaires/Perruques",
    setup399: "Les emballages scellés à usage unique pour les produits de soins capillaires (le cas échéant) doivent rester scellés.",
    setup400: "Soins de la peau/Soins du corps/Huiles essentielles",
    setup401: "L'emballage scellé jetable du produit (le cas échéant) doit rester scellé",
    setup402: "Cosmétiques/Parfums/Outils de beauté",
    setup403: "Produits numériques/appareils électroménagers (hors appareils photo et gros électroménagers)",
    setup404: "1. La licence d'accès Internet n'est pas endommagée (détruite).",
    setup405: "2. Aucun dégât des eaux.",
    setup406: "Appareil photo numérique/Appareil photo reflex/Appareil photo",
    setup407: "Le déclencheur d'un appareil photo reflex ne doit pas être enfoncé plus de 20 fois.",
    setup408: "Gros appareils électroménagers",
    setup409: "1. Téléviseur LCD, climatiseur: pas encore installé au mur, un débogage simple est disponible.",
    setup410: "2. Machine à laver: n'a pas encore été utilisée avec de l'eau.",
    setup411: "Modèles / Périphériques d'anime / Périphériques d'anime / Produits de jeux de rôle / Jeux de société",
    setup412: "Le ruban adhésif et les joints en plastique (le cas échéant) des modèles, figurines, modèles de soldats, BJD et autres produits ne peuvent pas être retirés.",
    setup413: "Composants électroniques",
    setup414: "1. Le soudage est interdit.",
    setup415: "2. Le circuit intégré n'a jamais été monté sur une base de circuit intégré.",
    setup416: "3. Les emballages scellés jetables de consommables tels que la graisse thermique, la colle électronique, la colle d'enrobage, le mastic, l'adhésif, la colle conductrice, l'encre conductrice, etc. doivent être conservés scellés.",
    setup417: "Sous-catégorie 'Logiciels de jeux' sous la catégorie de premier niveau 'Jeux vidéo/ Accessoires / Jeux / Guides de jeux",
    setup418: "Aliments pour animaux de compagnie, produits de santé et médicaments relevant de la catégorie de premier niveau 'Animaux de compagnie / Aliments et fournitures pour animaux de compagnie",
    setup419: "Livres/Magazines",
    setup420: "1. L'emballage scellé jetable du produit (le cas échéant) doit rester scellé",
    setup421: "2. Le produit ne doit présenter aucune trace de pliage, de taches d'eau, de saleté, d'encre ou de lecture.",
    setup422: "Catégorie secondaire 'Produits de santé animale/Médicaments vétérinaires' sous la catégorie principale 'Produits d'élevage/Agriculture'",
    setup423: "Les emballages scellés à usage unique (le cas échéant) pour des produits tels que les aliments (y compris les compléments alimentaires), les cosmétiques, les dispositifs médicaux, les contraceptifs, les produits de soins personnels, les produits pour adultes, les couches pour bébés, les livres et les produits audiovisuels doivent rester scellés.",
    setup424: "Le terme 'scellage' fait référence au sceau ou à l'emballage en plastique utilisé par le fabricant sur l'emballage du produit.",
    setup425: "Foire aux questions:",
    setup426: "1. Que dois-je faire si une commande non couverte par la 'Garantie de retour et d'échange' rencontre des problèmes après - vente ? ",

    setup427: "En cas de problème de qualité du produit, 51shopy vérifiera auprès du vendeur la situation réelle, proposera une solution définitive et informera l'utilisateur. En l'absence de problème de qualité, conformément aux règles de la plateforme tierce, les services de retour et d'échange ne pourront être assurés. 51shopy fera tout son possible pour communiquer avec le vendeur afin de protéger les droits et les intérêts des utilisateurs.",
    setup428: "2. Qui est responsable de l'expédition lors de l'utilisation de la 'Garantie de retour/échange' ? ",
    setup429: "Avant de demander un retour ou un échange, le produit doit être neuf et conforme aux conditions de revente. Si le produit ne présente aucun défaut de qualité, les frais de port seront à la charge de l'utilisateur. En cas de défaut de qualité, les frais de port seront à la charge du vendeur après la soumission de la demande.",
    setup430: "3. Si le statut de la commande n'est pas expédié, y a-t-il des frais de retour?",
    setup431: "Ne vous inquiétez pas, aucun frais ne vous sera facturé dans ce cas. Vous ne serez facturé que si la demande de retour remplit trois conditions: premièrement, le produit ne présente aucun problème de qualité; deuxièmement, le produit est déjà en stock dans notre entrepôt; troisièmement, vous avez utilisé le nombre de retours gratuits ce mois-ci. Par conséquent, nous ne vous facturerons rien si le produit n'a pas été expédié.",
    setup432: "E-mail:",
    setup433: "Tél.: +85251387262",
    setup434: "Adresse: Salle 341, 3e étage, Bâtiment industriel public, 56 Hoi Yuen Road, Kwun Tong, Hong Kong",
    setup435: "Propulsé par 51shopy - Space Network Technology Co., Ltd.",
    setup436: "Vous assister dans le traitement",
    setup437: "Vente chaude d'hier",
    setup438: "Vente chaude",
    setup439: "Vendu",
    setup440: "Paiement échoué",
    setup441: "En attente du paiement des frais de port",
    setup442: "Frais de port payés, en attente de confirmation de la banque",
    setup443: "Frais de port payés",
    setup444: "Spécifications",
    setup445: "Paiement réel",
    setup446: "Il est recommandé de bien réfléchir avant d'annuler une commande. La plateforme ne sera pas tenue responsable de l'annulation d'une commande!",
    setup447: "Changer de paiement",
    setup448: "Payer les frais de port",
    setup449: "Commande commerciale",
    setup450: "Plus",
    setup451: "mail",
    setup452: "Achat",
    setup453: "Libérer",
    setup454: "Vendre",
    setup455: "Historique",
    setup456: "Bon de commande",
    setup457: "Montant à payer",
    setup458: "Entrez dans le magasin",
    setup459: "Voir plus",
    setup460: "Réduire",
    setup461: "Entrée",
    setup462: "Le produit est en rupture de stock.",
    setup463: "Nous recommandons les produits similaires suivants",
    setup464: "Produits similaires",
    setup465: "Avertissement",
    setup467: "L'emballage désigne l'emballage d'origine du produit. En cas d'inspection, l'emballage logistique sera retiré, à l'exception du produit lui-même. Afin d'éviter tout dommage au produit, les matériaux d'emballage de protection nécessaires seront conservés. Nous déclinons toute responsabilité si vous demandez le retrait de l'emballage.",
    setup468: "Fret national complet Pour les marchandises du même vendeur, l'écart de fret sera ajusté par nos soins.",
    setup469: "Pour chaque produit, nous prendrons gratuitement 3 à 7 photos. Si vous avez des exigences supplémentaires pour des services photo de qualité, nous pouvons facturer des frais de service minimes.",
    setup470: "Les produits personnalisés ne prennent pas en charge les retours ou les échanges.",
    setup471: "Pour les produits dont le retour et l'échange ont été approuvés par le commerçant, vous pouvez effectuer une demande de retour et d'échange dans les 14 jours suivant le passage du statut de la commande à 'En stock'. Pour toute demande de retour et d'échange, des frais de traitement d'environ 0,75$US et des frais d'expédition nationaux sont à votre charge pour chaque produit retourné, soit un montant total d'environ 3$US.",
    setup472: "All",
    setup473: "Itinéraire d'affranchissement",
    setup474: "Frais d'expédition",
    setup475: "Les informations de longueur, de largeur et de hauteur du colis sont obligatoires",
    setup476: "Temps de transport",
    setup477: "jour",
    setup478: "Hors taxes",
    setup479: "Peut être assuré",
    setup480: "Estimation",
    setup481: "Récupérer le registre des mots de passe",
    setup482: "Marchand",
    setup483: "S'il vous plaît",
    setup484: "Payer, sinon la commande sera annulée",
    setup485: "Prix total des marchandises",
    setup486: "Montant eff.",
    setup487: "Payer maintenant",
    setup488: "Le solde est insuffisant, veuillez recharger et payer",
    setup489: "Aucun moyen de paiement approprié? Vous pouvez d'abord essayer de payer avec votre solde",
    setup490: "Déjà en stock",
    setup491: "Le fret a été estimé",
    setup492: "Frais d'expédition payés",
    setup493: "Expédier en rupture de stock",
    setup494: "Continuer à payer",
    setup495: "Numéro de commande logistique internationale",
    setup496: "Numéro de commande logistique nationale",
    setup497: "Votre navigateur ne prend pas en charge le lecteur vidéo HTML5.",
    setup498: "Prend uniquement en charge le téléchargement d'images aux formats PNG et JPEG!",
    setup499: "Terminé",
    setup500: "retour",
    setup501: "Vous n'avez pas l'autorisation d'accéder à cette page",
    setup502: "Calcul du transport",
    setup503: "Coopérer avec de nombreuses entreprises de logistique pour offrir les remises les plus avantageuses",
    setup504: "Estimation",
    setup505: "Rechercher des produits",
    setup506: "Afficher les produits en fonction des critères de recherche",
    setup507: "Informations de base",
    setup508: "Veuillez saisir le nom anglais",
    setup509: "Veuillez saisir le nom chinois",
    setup510: "Les vidéos téléchargées ne peuvent être qu'au format MP4, WebM ou OGG!",
    setup511: "La taille de la vidéo téléchargée ne peut pas dépasser 2Mo!",
    setup512: "La durée de la vidéo ne peut pas dépasser",
    setup513: "secondes",
    setup514: "Impossible d'obtenir la durée de la vidéo, veuillez vérifier si le fichier vidéo est endommagé",
    setup515: "données",
    setup516: "",
    setup517: "Veuillez saisir le SKU",
    setup518: "Veuillez saisir la quantité",
    setup519: "Veuillez saisir le prix",
    setup520: "Veuillez saisir les détails du produit en anglais",
    setup521: "Veuillez saisir les détails du produit chinois",
    setup522: "Chinois simplifié",
    setup523: "Espagnol",
    setup524: "Portugais",
    setup525: "Néerlandais",
    setup526: "Polonais",
    setup527: "Allemand",
    setup528: "Français",
    setup529: "Italien",
    setup530: "Activer plusieurs spécifications",
    setup531: "Prix (CNY)",
    setup532: "Aj.Photos Spec",
    setup533: "Aj. Val. Spec",
    setup534: "① Double-cliquez pour modifier, faites glisser pour ajuster l'ordre",
    setup535: "Ajouter des spécifications",
    setup536: "Paramètres par lots",
    setup537: "Veuillez publier côté PC",
    setup538: "Nom",
    setup539: "Télécharger la vidéo du produit",
    setup540: "Heure d'entrée dans l'entrepôt",
    setup541: "Heure de sortie de l'entrepôt ",
    setup543: "Ma version",
    setup544: "Veuillez vous authentifier en tant que commerçant avant de publier le produit",
    setup545: "Veuillez vous rendre sur le PC pour publier le produit",
    setup546: "destination",
    setup547: "États-Unis d'Amérique",
    setup548: "Poids (grammes)",
    setup549: "Catégorie de produit",
    setup550: "Veuillez sélectionner une catégorie",
    setup551: "longueur",
    setup552: "largeur",
    setup553: "hauteur",
    setup554: "RECHERCHE",
    setup555: "complet",
    setup556: "Peut être assuré",
    setup557: "hors taxes",
    setup558: "frais de livraison",
    setup559: "Informations sur la longueur, la largeur et la hauteur du colis requises",
    setup560: "Délai de transport",
    setup561: "jours",
    setup562: "Annulation du paiement annulée avec succès !",
    setup563: "jourRappel: Veuillez sélectionner votre pays de destination et le système recherchera les itinéraires disponibles à cet endroit",
    setup564: "Restrictions relatives aux colis",
    setup565: "Limite de poids minimum:",
    setup566: "Limite de poids maximum:",
    setup567: "Règles de facturation au volume et au poids:",
    setup568: "Limite de taille:",
    setup569: "Envoi impossible",
    setup570: "Envoi possible",
    setup571: "Normes tarifaires:",
    setup572: "Unité de poids",
    setup573: "Prix unitaire",
    setup574: "Frais de douane",
    setup575: "Coût du carburant",
    setup576: "Frais d'exploitation",
    setup577: "La limite de crédit de cette banque est insuffisante, vous ne pouvez donc pas sélectionner cette banque!",
    setup578: "Le solde de 51coins est insuffisant, veuillez recharger!",
    setup579: "remarque",
    setup580: "Veuillez sélectionner le produit que vous souhaitez supprimer!",
    setup581: "Se connecter avec Google",
    setup582: "La première image est l'image principale par défaut. Glissez pour modifier.",
    setup583: "Limite de téléchargement maximale atteinte",
    setup584: "Connexion avec Telegram",
    setup585: "Voir la logistique",
    setup586: "Renseignements logistiques",
    setup587: "Modifier le numéro de commande logistique",
    setup588: "Binding mailbox ",
    setup589: "S'il vous plaît lier la boîte aux lettres d'abord",
    setup590: "Vous pouvez saisir jusqu'à 2 types de spécifications!",
    setup591: "Modèles communs",
    setup592: "Sélectionner le modèle",
    setup593: "Annuler",
    setup594: "Ajouter",
    setup595: "Veuillez sélectionner la valeur de spécification",
    setup596: "Ne pas ajouter à plusieurs reprises",
    setup597: "Configuration réussie des modèles communs!",
    setup598: "Le SKU ne peut pas être vide",
    setup599: "Le prix ne peut pas être vide",
    setup600: "La quantité ne peut pas être vide",
    setup601: "Impossible d'ajouter la même valeur de spécification!",
    setup602: "1Double-cliquez pour modifier",
    setup603: "Veuillez remplir les informations de spécification!",
    setup604: "Veuillez remplir les détails du produit en chinois simplifié et en anglais!",
    setup605: "Modification réussie",
    setup606: "Ajout réussi de la valeur de spécification!",
    setup607: "Définir comme commun",
    setup608: "Remplissez au moins une valeur de spécification!",
    setup609: "Veuillez saisir du chinois simplifié",
    setup610: "Veuillez saisir l'anglais",
    setup611: "Veuillez saisir l'espagnol",
    setup612: "Veuillez saisir le portugais",
    setup613: "Veuillez saisir le néerlandais",
    setup614: "Veuillez saisir le polonais",
    setup615: "Veuillez saisir l'allemand",
    setup616: "Veuillez saisir le français",
    setup617: "Veuillez saisir l'italien",
    setup618: "Auto-Traduction",
    setup619: "Traduction",
    setup620: "Tous les autres",
    setup621: "INFORMATIONS DE LIVRAISON",
    setup622: "Notre objectif est de vous offrir les meilleures options de livraison, où que vous habitiez. Nous livrons chaque jour des centaines de clients à travers le monde et nous nous efforçons de vous fournir des services de la plus haute qualité.",
    setup623: "A. Le délai de livraison d'une commande est divisé en deux parties:",
    setup624: "· Délai de traitement: 3 à 7 jours",
    setup625: "· Délai de livraison: 14 à 30 jours",
    setup626: "B. Modes de livraison",
    setup627: "C. Frais de livraison",
    setup628: "Droits de propriété intellectuelle",
    setup629: "Transport terrestre/maritime",
    setup630: "En attente de réception",
    setup631: "alliance",
    setup632: "Partagez votre code d'affiliation",
    setup633: "Les amis que vous avez invités confirment qu'ils ont reçu votre code d'alliance",
    setup634: "Recevez votre commission d'affiliation",
    setup635: "Copiez cette URL et utilisez-la pour rediriger les utilisateurs vers la page d'accueil de votre identifiant d'affilié",
    setup636: "Copier l'URL",
    setup637: "Mon Alliance",
    setup638: "Enregistrement",
    setup639: "Obtenir",
    setup640: "FAQ sur les actions",
    setup641: "Qu'est-ce que le programme d'affiliation?",
    setup642: "51Shopy est un projet de partage et de gain initié par tous les utilisateurs. Que vous soyez particulier ou vendeur, rejoignez un promoteur 51Shopy, invitez de nouveaux utilisateurs à s'inscrire et à effectuer des achats. Ils deviendront votre utilisateur exclusif et chacune de leurs opérations logistiques internationales vous rapportera des remises en espèces, pouvant atteindre un million de yuans, sans limite.",
    setup643: "Comment mon bonus est-il calculé ?",
    setup644: "Une fois membre, votre compte bénéficiera immédiatement d'une réduction. Plus vous invitez d'utilisateurs de fret logistique international à s'inscrire, plus vous recevrez de bonus et plus votre réduction sera élevée. Lorsque le bonus atteint un certain montant, vous pouvez demander un retrait d'espèces ou l'utiliser pour compenser les frais de service de la plateforme 51Shopy. Le taux de réduction est de",
    setup645: "Comment promouvoir gratuitement?",
    setup646: "Copiez votre lien promotionnel et envoyez-le à vos amis en cliquant sur «Partager» sur la page produit. Lors de leur visite et inscription, ils deviendront votre utilisateur unique.",
    setup647: "Heure d'enregistrement",
    setup648: 'Frais de transport',
    setup649: "État d'activation",
    setup650: "Enregistrement bonus",
    setup651: "Heure d'application",
    setup652: "Récompense totale",
    setup653: "Inviter des utilisateurs",
    setup654: "Accéder au portefeuille",
    setup655:"Carte de crédit",
    setup656: "Invitez des amis à profiter de la commission",
    setup657:"Membre affilié",
    setup658:"Bon de commande",
    setup659:"La plateforme d'agents 51Shopy vous accompagne dans vos achats de produits en ligne et hors ligne en Chine. Il vous suffit de fournir le lien du produit et de passer commande. Notre équipe vous offrira un service de premier ordre du début à la fin.",
    setup660:"Expédier à l'entrepôt",
    setup661:"Avec nous, vous pouvez acheter des produits auprès de différents vendeurs et les faire expédier à l'entrepôt de 51Shopy en Chine",
    setup662:"Contrôle qualité",
    setup663:"Une fois vos articles arrivés à l'entrepôt 51Shopy, nous effectuons un contrôle qualité approfondi, couvrant tous les aspects, des défauts à la taille en passant par la couleur. Soyez assuré que 51Shopy offre un service après-vente fiable.",
    setup664:"Livraison mondiale",
    setup665:"Dans l'entrepôt 51Shopy, vous pouvez choisir et combiner librement les produits, et utiliser le service logistique fiable fourni par 51Shopy pour les emballer et les livrer à votre domicile.",
    setup666:"Service unique, sans souci tout au long du processus",
    setup667:"Une fois que les utilisateurs que vous invitez s'inscrivent, ils recevront USD:",
    setup668: "Livraison gratuite",
setup669: "Hors frais de port",
setup670: "L'expédition internationale n'est pas incluse",
setup671:"Société de logistique",
setup672: "Sélectionnez une entreprise de logistique",
setup673: "Dernier numéro de l'expéditeur",
setup674: "Quatre derniers chiffres",
setup675: "Numéro d'expéditeur",
setup676:"Veuillez saisir",
setup677:"En attente de stockage",
setup678:"Est-ce que cela inclut les frais de port internationaux?",
setup679:"Oui",
setup680:"Non",
setup681:"Cliquez sur le bouton «Ajouter à l'écran d'accueil»",
}
//法语